/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { type AssistantStep, Steps, type TypeActe } from '@/types';

/**
 * Métadonnées de chaque étape, définies une seule fois et réutilisées par tous
 * les types d'acte qui incluent l'étape.
 */
export const ASSISTANT_STEPS: Record<
  Steps,
  Omit<AssistantStep, 'validated'>
> = {
  [Steps.Acte]: {
    step: Steps.Acte,
    title: 'Acte',
    dataTestId: 'assistant-step-acte',
  },
  [Steps.Enfant]: {
    step: Steps.Enfant,
    title: 'Enfant',
    dataTestId: 'assistant-step-enfant',
  },
  [Steps.Parents]: {
    step: Steps.Parents,
    title: 'Parents',
    dataTestId: 'assistant-step-parents',
  },
  [Steps.Mentions]: {
    step: Steps.Mentions,
    title: 'Mentions',
    dataTestId: 'assistant-step-mentions',
  },
  [Steps.Defunt]: {
    step: Steps.Defunt,
    title: 'Défunt',
    dataTestId: 'assistant-step-defunt',
  },
  [Steps.Declarant]: {
    step: Steps.Declarant,
    title: 'Déclarant',
    dataTestId: 'assistant-step-declarant',
  },
  /*
   * Étapes du mariage. Les deux étapes de parents portent le MÊME titre, comme
   * la maquette : celui du conjoint concerné se lit dans l'étape qui précède.
   * Seuls les `dataTestId` les distinguent.
   */
  [Steps.Conjoint1]: {
    step: Steps.Conjoint1,
    title: '1er conjoint',
    dataTestId: 'assistant-step-conjoint1',
  },
  [Steps.ParentsConjoint1]: {
    step: Steps.ParentsConjoint1,
    title: 'Parents',
    dataTestId: 'assistant-step-parents-conjoint1',
  },
  [Steps.Conjoint2]: {
    step: Steps.Conjoint2,
    title: '2eme conjoint',
    dataTestId: 'assistant-step-conjoint2',
  },
  [Steps.ParentsConjoint2]: {
    step: Steps.ParentsConjoint2,
    title: 'Parents',
    dataTestId: 'assistant-step-parents-conjoint2',
  },
};

export const STEPS_BY_TYPE_ACTE: Partial<Record<TypeActe, Steps[]>> = {
  naissance: [Steps.Acte, Steps.Parents, Steps.Mentions],
  reconnaissance: [Steps.Acte, Steps.Enfant, Steps.Parents, Steps.Mentions],
  // Cinq étapes : l'acte, le défunt, ses parents, le déclarant, les mentions.
  deces: [
    Steps.Acte,
    Steps.Defunt,
    Steps.Parents,
    Steps.Declarant,
    Steps.Mentions,
  ],
  // Six étapes, le plus long des quatre parcours : l'acte, chaque conjoint et
  // ses parents, les mentions.
  mariage: [
    Steps.Acte,
    Steps.Conjoint1,
    Steps.ParentsConjoint1,
    Steps.Conjoint2,
    Steps.ParentsConjoint2,
    Steps.Mentions,
  ],
};
